import { render, staticRenderFns } from "./LegacyMobileSummary.vue?vue&type=template&id=248d4df2&"
import script from "./LegacyMobileSummary.vue?vue&type=script&lang=js&"
export * from "./LegacyMobileSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports